import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

export class RdsVariableUtil {
  /**
   * @param v1 First variable to compare
   * @param v2 Second variable to compare
   * @returns Whether the two variables are the same
   */
  static compareVariables(v1: Variable | VariableSummary | null | undefined, v2: Variable | VariableSummary | null | undefined): boolean {
    if (!v1 || !v2) {
      return false;
    }
    let hasMatchingUri = false;
    let hasMatchingId = false;
    if ('uri' in v1 && !!v1.uri && 'uri' in v2 && !!v2.uri) {
      hasMatchingUri = v1.uri === v2.uri;
    }
    if ('id' in v1 && !!v1.id && 'id' in v2 && !!v2.id) {
      hasMatchingId = v1.id === v2.id;
    }
    return hasMatchingUri || hasMatchingId;
  }

  /** Search function for filtering variables.
   * @param text check and see if this text exists in the variable's name, labal, or id
   * @param v variable to check
   * @returns whether the search text exists in a variable's name, label, or id
   */
  static filterVariable(text: string, v: Variable | VariableSummary): boolean {
    text = text || '';
    // Collect properties that exist on the variable to search
    let fieldsToSearch: string[] = [];
    if (v.name) {
      fieldsToSearch = [...fieldsToSearch, v.name];
    }
    if (v.label) {
      fieldsToSearch = [...fieldsToSearch, v.label];
    }
    if (v.id) {
      fieldsToSearch = [...fieldsToSearch, v.id];
    }
    // lowercase them all
    fieldsToSearch = fieldsToSearch.map((f) => f.toLowerCase());
    return fieldsToSearch.some((f) => f.includes(text.toLowerCase()));
  }
}
